import React, { useEffect, useState } from 'react'
import UserModel from './models/UserModel'

function ViewUser(props) {
  const [userData, setUserData] = useState(new UserModel());

  useEffect(() => {
    setUserData(props.UserData);
  }, [props.UserData])
  return (
    <>
      <div className="row">
        <div className="mb-3 add-product">
          <label className="form-label">Full Name</label>
          <input type="text" className="form-control" value={userData.FullName} disabled />
        </div>
        <div className="mb-3 add-product">
          <label className="form-label">Email</label>
          <input type="text" className="form-control" value={userData.Email} disabled />
        </div>
        <div className="mb-3 add-product">
          <label className="form-label">User Name</label>
          <input type="text" className="form-control" value={userData.UserName} disabled />
        </div>
        <div className="mb-3 add-product">
          <label className="form-label">Mobile No</label>
          <input type="text" className="form-control" value={userData.PhoneNumber} disabled />
        </div>
        <div className="mb-3 add-product">
          <label className="form-label">User Role</label>
          <input type="text" className="form-control" value={userData.RoleName} disabled />
        </div>
        <div className="mb-3 add-product">
          <label className="form-label">Default Module Name</label>
          <input type="text" className="form-control" value={userData.DefaultModuleName} disabled />
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6 col-sm-6 col-12">
          <div className="form-check form-switch">
          <input className="form-check-input" type="checkbox" role="switch" id="EmailConfirmation" disabled/>
          <label className="form-check-label" >Email Confirmation</label>
          </div>
        </div>
        <div className="col-lg-6 col-sm-6 col-12">
          <div className="form-check form-switch">
          <input className="form-check-input" type="checkbox" role="switch" id="MobileNoConfirmation" disabled/>
          <label className="form-check-label" >MobileNo Confirmation</label>
          </div>
        </div>
      </div>
    </>
  )
}

export default ViewUser